module.exports = __webpack_public_path__ + "assets/img/Coolabah-Turf-Service-Page.fc53ba00.jpg";